export const LAST_TICKET_STORAGE_KEY = "jdca:last-ticket-id";
export const PREMIUM_UNLOCK_STORAGE_KEY = "jdca:premium-unlocked";
export const AUTH_TOKEN_STORAGE_KEY = "jdca:access-token";
export const AUTH_EXPIRES_AT_STORAGE_KEY = "jdca:access-token-exp";
export const AUTH_STORAGE_VERSION_KEY = "jdca:auth-storage-version";
export const AUTH_SESSION_MODE_STORAGE_KEY = "jdca:auth-session-mode";

export type AuthSessionMode = "guest" | "account";

export const readStoredTicketId = (): string => {
  try {
    return localStorage.getItem(LAST_TICKET_STORAGE_KEY) ?? "";
  } catch {
    return "";
  }
};

export const persistTicketId = (ticketId: string): void => {
  try {
    localStorage.setItem(LAST_TICKET_STORAGE_KEY, ticketId);
  } catch {
    // Ignore storage failures.
  }
};

export const readPremiumUnlocked = (): boolean => {
  try {
    return localStorage.getItem(PREMIUM_UNLOCK_STORAGE_KEY) === "true";
  } catch {
    return false;
  }
};

export const persistPremiumUnlocked = (value: boolean): void => {
  try {
    localStorage.setItem(PREMIUM_UNLOCK_STORAGE_KEY, value ? "true" : "false");
  } catch {
    // Ignore storage failures.
  }
};

export const readAccessToken = (): string => {
  try {
    return localStorage.getItem(AUTH_TOKEN_STORAGE_KEY) ?? "";
  } catch {
    return "";
  }
};

export const readAuthSessionMode = (): AuthSessionMode | "" => {
  try {
    const raw = localStorage.getItem(AUTH_SESSION_MODE_STORAGE_KEY);
    return raw === "guest" || raw === "account" ? raw : "";
  } catch {
    return "";
  }
};

export const persistAuthSessionMode = (mode: AuthSessionMode): void => {
  try {
    localStorage.setItem(AUTH_SESSION_MODE_STORAGE_KEY, mode);
  } catch {
    // Ignore storage failures.
  }
};

export const hasActiveAccountSession = (): boolean => {
  const token = readAccessToken().trim();
  if (!token) {
    return false;
  }
  return readAuthSessionMode() === "account";
};

export const hasActiveSessionToken = (): boolean => {
  const token = readAccessToken().trim();
  if (!token) {
    return false;
  }
  return true;
};

export const clearSessionStorageState = (): void => {
  try {
    localStorage.removeItem(AUTH_TOKEN_STORAGE_KEY);
    localStorage.removeItem(AUTH_EXPIRES_AT_STORAGE_KEY);
    localStorage.removeItem(PREMIUM_UNLOCK_STORAGE_KEY);
    localStorage.removeItem(LAST_TICKET_STORAGE_KEY);
    localStorage.removeItem(AUTH_STORAGE_VERSION_KEY);
    localStorage.removeItem(AUTH_SESSION_MODE_STORAGE_KEY);
  } catch {
    // Ignore storage failures.
  }
};
